import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataInicio = (): TabelaColuna => ({
  Chave: 'dataInicio',
  Texto: 'Data Início',
  StyleColuna: { width: 100, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => (
    <>{formatadores.dataLocaleString(linha.dataInicio)}</>
  )
})
